<template>
  <div>
    <h2 :class="['cancel_heading', {'is-centered': isCentered}]">
      <slot></slot>
    </h2>
    <p v-if="subheading" class="cancel_subheading">{{ subheading }}</p>
  </div>
</template>

<script>
export default {
  name: "CancelHeading",
  props: {
    isCentered: {
      type: Boolean,
      default: false
    },
    subheading: String,
  },
}
</script>

<style lang="scss" scoped>
.cancel_heading {
  margin-bottom: 12px;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1.2;

  &.is-centered {
    text-align: center;
  }
}

.cancel_subheading {
  margin: -4px 0 8px;
  font-size: 0.875rem;
}
</style>
